module.exports = __webpack_public_path__ + "static/img/100_fot_bmw_sw.c36963b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/100_fot_bmw_sw.jpeg
// module id = CNzT
// module chunks = 1